<template>
  <div>
    <navbar-component />
    <div class="bg-container">
      <subcatalog-searchbar-layout :texts="texts"></subcatalog-searchbar-layout>
      <subcatalog-content-layout :texts="texts"></subcatalog-content-layout>
    </div>
    <footer-component />
    <whatsapp-component />
  </div>
</template>

<script>
export default {
  name: "SubcatalogView",
  data() {
    return {
      //VARIABLES
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.subcatalog[this.selectLanguage];
  },
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.subcatalog[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.bg-container {
 width: 100%;
  min-height: 82.5%;

  background: #f2f2f4 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-top: 0px;
  padding-top: 75px;
}
</style>